import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Agreement {
    agreed: boolean;
    stamp?: Number;
}

export const initialState = {
    agreed: false
} as Agreement;

const agreementSlice = createSlice({
    name: "agreement",
    initialState,
    reducers: {
        updateAgreement(state, action: PayloadAction<boolean>) {
            state.agreed = action.payload;
            state.stamp = action.payload ? Date.now() : undefined;
        }
    }
});

export const { updateAgreement } = agreementSlice.actions;

export default agreementSlice.reducer;
